<template>
    <div class="subtitle-localization-cue text-primary">
        <div class="row">
            <div class="col-xs-1" style="white-space:nowrap;">
                #{{ number }}
                <i
                        style="margin-left: 5px;"
                        class="fa fa-eye tool_tip"
                        :title="workInProgress"
                        data-toggle="tooltip">

                </i>
            </div>

            <div class="col-xs-12">
                <subtitle-cue-textarea
                        :lines="workInProgress"
                        :name="'edits['+number+']'"
                        :key="number"
                        :required="'required'"
                        :hideWarnings="true"
                        :disabled="false">
                </subtitle-cue-textarea>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'number',
            'workInProgressLines',
            'comment',
        ],

        computed: {
            workInProgress: function() {
                return this.workInProgressLines;
            },
        },
    };
</script>
